import { FileCheck, Scale, Clock, Shield, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

export default function AGB() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">

      <div className="relative pt-32 pb-16 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{ backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)', backgroundSize: '40px 40px' }}></div>
        </div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-green-600 rounded-2xl mb-6">
              <FileCheck className="w-8 h-8 text-white" />
            </div>
            <h1 className="text-2xl sm:text-3xl md:text-6xl font-bold text-white mb-6 leading-tight">Allgemeine Geschäftsbedingungen</h1>
            <p className="text-xl text-slate-300 max-w-2xl mx-auto">
              Transparente und faire Bedingungen für Ihren Umzug zwischen der Schweiz und Deutschland.
            </p>
          </div>
        </div>
      </div>

      <main className="flex-grow bg-gradient-to-b from-slate-50 to-white py-20">
        <div className="container mx-auto px-4 max-w-4xl">
          <button
            onClick={() => navigate('/')}
            className="mb-8 inline-flex items-center space-x-2 text-slate-700 hover:text-slate-900 font-medium transition group"
          >
            <ArrowLeft className="w-5 h-5 group-hover:-translate-x-1 transition-transform" />
            <span>Zurück zur Startseite</span>
          </button>
          <div className="grid md:grid-cols-3 gap-6 mb-12">
            <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200">
              <Scale className="w-8 h-8 text-green-600 mb-3" />
              <h3 className="font-bold text-slate-900 mb-2">Fair & Transparent</h3>
              <p className="text-sm text-slate-600">Klare Regelungen ohne Kleingedrucktes</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200">
              <Clock className="w-8 h-8 text-green-600 mb-3" />
              <h3 className="font-bold text-slate-900 mb-2">Flexible Stornierung</h3>
              <p className="text-sm text-slate-600">Bis 14 Tage vorher kostenfrei</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200">
              <Shield className="w-8 h-8 text-green-600 mb-3" />
              <h3 className="font-bold text-slate-900 mb-2">Vollversichert</h3>
              <p className="text-sm text-slate-600">Umfassender Versicherungsschutz</p>
            </div>
          </div>

          <div className="prose prose-slate max-w-none space-y-6 text-slate-700">
            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">1. Geltungsbereich</h2>
              <p className="leading-relaxed">
                Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge zwischen der Clean & Umzug Profis AG
                (nachfolgend "Auftragnehmer" genannt) und dem Auftraggeber über die Erbringung von Umzugsdienstleistungen
                zwischen der Schweiz und Deutschland.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">2. Vertragsabschluss</h2>
              <p className="leading-relaxed mb-3">
                Der Vertrag kommt durch schriftliche Auftragsbestätigung oder durch Beginn der Ausführung der Dienstleistung zustande.
              </p>
              <p className="leading-relaxed">
                Angebote des Auftragnehmers sind freibleibend und unverbindlich, sofern sie nicht ausdrücklich als verbindlich
                gekennzeichnet sind.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">3. Leistungsumfang</h2>
              <p className="leading-relaxed mb-3">
                Der Auftragnehmer verpflichtet sich, die vereinbarten Umzugsleistungen fachgerecht und termingerecht durchzuführen.
                Der genaue Leistungsumfang ergibt sich aus der Auftragsbestätigung.
              </p>
              <p className="leading-relaxed">
                Zusätzliche Leistungen, die nicht im ursprünglichen Angebot enthalten sind, werden gesondert berechnet.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">4. Preise und Zahlungsbedingungen</h2>
              <p className="leading-relaxed mb-3">
                Alle angegebenen Preise verstehen sich in Schweizer Franken (CHF) zuzüglich der gesetzlichen Mehrwertsteuer.
              </p>
              <p className="leading-relaxed mb-3">
                Die Zahlung erfolgt nach Abschluss der Arbeiten, sofern nicht anders vereinbart. Bei größeren Aufträgen kann
                eine Anzahlung von bis zu 50% des Gesamtbetrags verlangt werden.
              </p>
              <p className="leading-relaxed">
                Bei Zahlungsverzug werden Verzugszinsen in Höhe von 5% über dem jeweiligen Basiszinssatz berechnet.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">5. Pflichten des Auftraggebers</h2>
              <p className="leading-relaxed">Der Auftraggeber ist verpflichtet:</p>
              <ul className="list-disc pl-6 space-y-2 mt-3">
                <li>Alle erforderlichen Genehmigungen und Halteverbotszonen zu organisieren</li>
                <li>Wertsachen, Geld und wichtige Dokumente selbst zu transportieren</li>
                <li>Zerbrechliche Gegenstände ordnungsgemäß zu kennzeichnen</li>
                <li>Den Auftragnehmer über besondere Umstände zu informieren (enge Treppenhäuser, fehlender Aufzug, etc.)</li>
                <li>Bei grenzüberschreitenden Umzügen alle notwendigen Zolldokumente bereitzustellen</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">6. Haftung und Versicherung</h2>
              <p className="leading-relaxed mb-3">
                Der Auftragnehmer haftet für Schäden an Umzugsgut nur bei Vorsatz oder grober Fahrlässigkeit. Die Haftung ist
                auf den Zeitwert der beschädigten Sache begrenzt.
              </p>
              <p className="leading-relaxed mb-3">
                Alle Transporte sind über eine Transportversicherung abgedeckt. Die genauen Versicherungsbedingungen werden auf
                Wunsch zur Verfügung gestellt.
              </p>
              <p className="leading-relaxed">
                Schäden müssen unverzüglich bei Übergabe des Umzugsguts schriftlich gemeldet werden. Spätere Reklamationen
                können nicht berücksichtigt werden.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">7. Stornierung und Rücktritt</h2>
              <p className="leading-relaxed">
                Bei Stornierung durch den Auftraggeber gelten folgende Regelungen:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-3">
                <li>Bis 14 Tage vor dem Umzugstermin: kostenfrei</li>
                <li>7-13 Tage vor dem Umzugstermin: 50% der vereinbarten Vergütung</li>
                <li>Weniger als 7 Tage vor dem Umzugstermin: 100% der vereinbarten Vergütung</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">8. Zollabwicklung</h2>
              <p className="leading-relaxed">
                Bei grenzüberschreitenden Umzügen zwischen der Schweiz und Deutschland unterstützt der Auftragnehmer bei der
                Zollabwicklung. Die Verantwortung für korrekte und vollständige Zollunterlagen liegt jedoch beim Auftraggeber.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">9. Höhere Gewalt</h2>
              <p className="leading-relaxed">
                Bei Eintritt höherer Gewalt (Naturkatastrophen, Streiks, Verkehrsbehinderungen, etc.) ist der Auftragnehmer
                von der Leistungspflicht befreit. Bereits erbrachte Leistungen werden anteilig berechnet.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">10. Schlussbestimmungen</h2>
              <p className="leading-relaxed mb-3">
                Es gilt Schweizer Recht unter Ausschluss des UN-Kaufrechts.
              </p>
              <p className="leading-relaxed mb-3">
                Gerichtsstand ist Aarau, sofern der Auftraggeber seinen Wohnsitz in der Schweiz hat.
              </p>
              <p className="leading-relaxed">
                Sollten einzelne Bestimmungen dieser AGB unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.
              </p>
            </section>

            <section className="bg-slate-100 p-6 rounded-lg mt-8">
              <p className="font-semibold text-slate-900">Kontakt</p>
              <p className="mt-2">Clean & Umzug Profis AG</p>
              <p>Hintere Bahnhofstrasse 83</p>
              <p>5000 Aarau</p>
              <p className="mt-3">Telefon: 0800 700 100</p>
              <p>E-Mail: info@umzugprofis.ch</p>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
}
